
import $ from 'jquery';

export var authorizeInStoriesOnBoardAndGetToken: () => Promise<string> = () => {
    return new Promise<string>((resolve, reject) => {
        const authWindow = openAuthWindow();

        var messageListener = (message: MessageEvent) => {
            var payload = message.data;
            if(payload.type != undefined && payload.type == "authping") {
                window.removeEventListener("message", messageListener, false);
                authWindow.close();

                //@ts-ignore
                var appRoot = process.env.APPLICATION_API_ROOT;

                fetch(`${appRoot}/auth/getusertoken`, {
                    method: "POST",
                    mode: "cors",
                    cache: "no-cache",
                    headers: {
                    "Content-Type": "application/json",
                    },
                    credentials: 'include'
                }).then((response) => {
                    if (response.ok) {
                        response.json().then((r) => resolve(r.token))
                    }
                    else {
                        resolve(null);
                    }
                });
            }
        }

        window.addEventListener("message", messageListener, false);
    })
}

var openAuthWindow = () => {
    var w = 500;
    var h = 700;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    return window.open("/views/authpopup.html", "Authorization...", 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=' + w + ', height=' + h + ',top=' + top + ',left=' + left);
}
